import React from 'react';
import { Tag } from '@neshane/blueberry';
import {
    OPERATION_STATUS_LABELS,
    OPERATION_STATUS_VARIANTS,
    DLQ_STATUS_LABELS,
    DLQ_STATUS_VARIANTS,
    COMPENSATION_STATUS_LABELS,
    COMPENSATION_STATUS_VARIANTS,
    CIRCUIT_STATE_LABELS,
    CIRCUIT_STATE_VARIANTS,
} from '../labels';

export const OperationStatusBadge = ({ status }) => (
    <Tag variant={OPERATION_STATUS_VARIANTS[status] || 'neutral'}>
        {OPERATION_STATUS_LABELS[status] || status}
    </Tag>
);

export const DlqStatusBadge = ({ status }) => (
    <Tag variant={DLQ_STATUS_VARIANTS[status] || 'neutral'}>
        {DLQ_STATUS_LABELS[status] || status}
    </Tag>
);

export const CompensationStatusBadge = ({ status }) => (
    <Tag variant={COMPENSATION_STATUS_VARIANTS[status] || 'neutral'}>
        {COMPENSATION_STATUS_LABELS[status] || status}
    </Tag>
);

export const CircuitStateBadge = ({ state }) => (
    <Tag variant={CIRCUIT_STATE_VARIANTS[state] || 'neutral'}>
        {CIRCUIT_STATE_LABELS[state] || state}
    </Tag>
);

export default OperationStatusBadge;